import React from 'react';
import PropTypes from 'prop-types';

// Component Styles
import './errorMessage.scss';

// App Config
import AppConfiguration from '../../../services/AppConfiguration';
/**
 * This component shows an error message given by props.
 */
class ErrorMessage extends React.Component {
  constructor(props) {
    super(props);

    /**
     * Instance of the App configuration data.
     * @type {Object}
     */
    this.appConfig = AppConfiguration.getConfig();
  }
  /**
   * Renders the close button of the error message
   * If hideCloseButton was provided as props, then the close button is not rendered
   *
   * @returns {ReactElement}  The close button react element
   */
  renderCloseButton() {
    let closeButton = null;

    if (!this.props.hideCloseButton) {
      closeButton = (
        <button className='wtfErrorMessage_closeIcon' onClick={this.props.onClose}>x</button>
      );
    }

    return closeButton;
  }

  render() {
    return (
      <div className='wtfErrorMessage'>
        <div className='wtfErrorMessage_icon'>
          <img
            className='wtfErrorMessage_iconImage'
            alt='Error Icon'
            src={`${this.appConfig.cdnUrl.url}/warning-icon.svg`}
          />
        </div>
        <p className='wtfErrorMessage_text'>{this.props.text}</p>
        {/* @TODO: Once we have the design for the `x` icon, change the following line */}
        { this.renderCloseButton() }
      </div>
    );
  }
}

/**
 * Set the ErrorMessage component props default values.
 * @type {Object}
 */
ErrorMessage.defaultProps = {
  text: '',
  hideCloseButton: false,
  onClose: () => {},
};

/**
 * Declare the ErrorMessage component PropTypes for better validation.
 * @type {Object}
 * @property {String}   text        The text displayed by the error message
 * @property {Boolean}  hideButton  The flag to control when the close button should be hidden
 * @property {Function} onClose     The callback that is executed when the close button is clicked
 */
ErrorMessage.propTypes = {
  text: PropTypes.string,
  hideCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/common/ErrorMessage/ErrorMessage.js